import {
    COUNTRY_CLAUSE_LIST,
    COUNTRY_CLAUSE_REGION_LIST,
    COUNTRY_CLAUSE_PAGINATION
} from './constant';

export const initStateFeed = {
    countryclauseList: [],
    countryclauseRegionList: [],
    pagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case COUNTRY_CLAUSE_LIST: {
            return {
                ...state,
                countryclauseList: action?.payload,
            };
        }
        case COUNTRY_CLAUSE_REGION_LIST: {
            return {
                ...state,
                countryclauseRegionList: action?.payload,
            };
        }
        
        case COUNTRY_CLAUSE_PAGINATION: {
            return {
                ...state,
                pagination: action?.payload,
            };
        }
        default:
            return state;
    }
};
 